import React from "react";
import { Outlet } from "react-router-dom";

function Loading({ children }) {
  return (
    <>
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <div className="ml-5 text-[30px]">
          {children ? children : <Outlet />}
        </div>
      </div>
    </>
  );
}

export default Loading;
